import React, { FC, ReactNode } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { actionCreators, AppState, State } from '../../state';
import './ModuleCompleted.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRotateLeft, faHouseChimney } from '@fortawesome/free-solid-svg-icons'
import SubModuleCard from '../SubModuleCard/SubModuleCard';
import TrainingCard from '../TrainingCard/TrainingCard';
import { UserRole, getTrainingForUserRole, UserTraining, TrainingModule } from '../../models/index'

interface ModuleCompletedProps {
  didRestart: (() => void)
}

const ModuleCompleted: FC<ModuleCompletedProps> = ({didRestart}: ModuleCompletedProps) => {

  const { navState, trainingState, role } = useSelector((state: State) => state)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { updateNavState, updateTrainingState, clearNavState, clearTrainingState, updateAppState } = bindActionCreators(actionCreators, dispatch)

  function getSubModuleInfo() {
    const training = trainingState.currentTraining
    let subModuleIndex = training!.currentSubModuleIndex
    let useAlternates = false
    if (subModuleIndex < 0) {
        useAlternates = true
        subModuleIndex = Math.abs((subModuleIndex + 1))
    }
    const subMod = useAlternates ? training!.alternateModules![subModuleIndex] : training?.subModules[subModuleIndex]
    return subMod
  }
  function getSteps() {
    const subMod = getSubModuleInfo()
    return subMod?.steps ?? []
  }

  const userTraining: UserTraining = getTrainingForUserRole(role as UserRole)
  function restartMod() {
    var ns = navState.stack
    var training = trainingState.currentTraining!
    const startIndex = ns.length - (getSteps().length - 1)
    const itemsToRemove = ns.length - startIndex
    ns.splice(startIndex, itemsToRemove)
    const path = '/module'
    training.currentSubModuleIndex = training.currentSubModuleIndex ?? 0
    training.currentStepIndex = 0
    updateTrainingState({currentTraining: training})
    updateNavState({stack: ns})
    didRestart()
    navigate(path)
  }

  function returnHome() {
    updateAppState(AppState.NoAnimation)
    clearNavState()
    clearTrainingState()
    navigate('/')
  }

  const subModCards = ():ReactNode[] | undefined => {
    const subMod = getSubModuleInfo()
    if (subMod && subMod.suggestedNextSteps) {
      return subMod.suggestedNextSteps!.map((module, index) => {
        return (
          <SubModuleCard 
            key={index} 
            subModule={module}
            index={index}
          />
        )
      })
    }
    if (trainingState.currentTraining!.subModules.length > 1) {
      return trainingState.currentTraining?.subModules.map((module, index) => {
        if (index === trainingState.currentTraining?.currentSubModuleIndex || 
          //This secondary condition is to handle the edge case where we have two modules accessible for the SmartShelf replenisment training
          (trainingState.currentTraining?.currentSubModuleIndex === -1 && index === trainingState.currentTraining.subModules.length - 1)) {
          return null
        } 
        return (
          <SubModuleCard 
            key={index} 
            subModule={module}
            index={index}
          />
        )
      })
    }
  }
  const other = userTraining.required.filter((value: TrainingModule) => { return value !== trainingState.currentTraining?.trainingModule }).length === 0 ? 
                userTraining.optional?.filter((value: TrainingModule) => { return value !== trainingState.currentTraining?.trainingModule }) : userTraining.required.filter((value: TrainingModule) => { return value !== trainingState.currentTraining?.trainingModule })
  const otherTrainingCards = other?.map((module, index) => {
    return (
      <TrainingCard 
        key={index}
        module={module}
        small={true}
        customClass={'moduleCompleted'}
      />
    )
  })

  return (
    <div className="ModuleCompleted">
      <div className="mc-main-container">
        <div className="title">{getSubModuleInfo()!.name} complete!</div>
        <div className="restart" onClick={restartMod}>
          <FontAwesomeIcon icon={faArrowRotateLeft} style={{ fontSize: '38px', color: 'var(--crimson)', marginRight: '6px' }} />
          Repeat {getSubModuleInfo()!.name.toLocaleLowerCase()} process
        </div>
        <span>Suggested next steps:</span>
        <div className="subModuleCardsContainer">
          {subModCards()}
        </div>
        <span>Other Components:</span>
        <div className="trainingCardContainer">
          {otherTrainingCards}
        </div>
        <div className="footer">
          <FontAwesomeIcon onClick={returnHome} icon={faHouseChimney} style={{ fontSize: '32px', color: 'var(--logo-gray)', opacity: '0.9', cursor: 'pointer' }} />
        </div>
      </div>
    </div>
  )
};

export default ModuleCompleted;
